<template>
    <div class="ps-product-categories-tabs">
        <ul class="ps-section__links" v-if="tabsData.length > 1">
            <li v-for="tab in tabsData" :key="tab.id">
                <a :class="activeTab.id === tab.id ? 'active': ''"
                   :id="'tab-' + tab.slug + '-tab'"
                   data-toggle="tab"
                   :href="'#tab-' + tab.slug"
                   role="tab"
                   :aria-controls="'tab-' + tab.slug"
                   aria-selected="true"
                   @click.prevent="switchTab(tab)"
                   v-html="tab.name">
                </a>
            </li>
            <!-- <li v-if="showViewAll"><a :href="allUrl">{{ __('View All') }}</a></li> -->
        </ul>
        <div class="ps-section__content">
            <div class="half-circle-spinner" v-if="isLoading">
                <div class="circle circle-1"></div>
                <div class="circle circle-2"></div>
            </div>
            <div class="tab-pane fade show active"
                 v-if="!isLoading && currentData.length"
                 :id="'tab-' + activeTab.slug"
                 role="tabpanel"
                 :aria-labelledby="'tab-' + activeTab.slug + '-tab'"
                 :key="'tab-' + activeTab.id + '-' + renderKey">
                <div v-carousel class="ps-carousel--nav owl-slider"
                     data-owl-auto="false"
                     data-owl-loop="false"
                     data-owl-speed="10000"
                     data-owl-gap="20"
                     data-owl-nav="true"
                     data-owl-dots="true"
                     data-owl-item="4"
                     data-owl-item-xs="2"
                     data-owl-item-sm="2"
                     data-owl-item-md="3"
                     data-owl-item-lg="4"
                     data-owl-item-xl="4"
                     data-owl-duration="1000"
                     data-owl-mousedrag="on"
                >
                    <div class="ps-product ps-product--grid" v-for="(item, index) in currentData" :key="index" v-html="item"></div>
                </div>
            </div>
            <div v-if="!isLoading && !currentData.length" class="text-center py-4">
                <p class="text-muted">{{ __('No products found.') }}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return {
            isLoading: false,
            activeTab: {},
            cache: {},
            renderKey: 0,
            tabsData: []
        };
    },

    computed: {
        currentData() {
            if (!this.activeTab.id) return [];
            return this.cache[this.activeTab.id] || [];
        }
    },

    mounted() {
        // Charger les données depuis window si dataId est défini
        let tabsData = this.tabs;
        let initialDataArr = this.initialData;

        if (this.dataId && window[this.dataId]) {
            tabsData = window[this.dataId].tabs || [];
            initialDataArr = window[this.dataId].initialData || [];
        }

        if (tabsData.length) {
            this.activeTab = tabsData[0];
            this.tabsData = tabsData;

            if (initialDataArr && initialDataArr.length) {
                this.cache[this.activeTab.id] = initialDataArr;
            } else {
                this.fetchData(this.activeTab);
            }
        }
    },

    props: {
        dataId: {
            type: String,
            default: () => null,
        },
        tabs: {
            type: Array,
            default: () => [],
        },
        url: {
            type: String,
            default: () => null,
            required: true
        },
        allUrl: {
            type: String,
            default: () => '/products',
        },
        showViewAll: {
            type: Boolean,
            default: () => true,
        },
        initialData: {
            type: Array,
            default: () => [],
        }
    },

    methods: {
        switchTab(tab) {
            if (this.activeTab.id === tab.id) return;

            this.activeTab = tab;
            this.renderKey++;

            if (this.cache[tab.id]) {
                return;
            }

            this.fetchData(tab);
        },

        fetchData(tab) {
            this.isLoading = true;

            let params = new URLSearchParams();
            params.append('limit', tab.limit || 12);
            params.append('source_type', tab.source_type);

            if (tab.source_type === 'categories_brands') {
                if (tab.category_ids && tab.category_ids.length) params.append('category_ids', tab.category_ids.join(','));
                if (tab.brand_ids && tab.brand_ids.length) params.append('brand_ids', tab.brand_ids.join(','));
            } else if (tab.source_type === 'collections') {
                if (tab.collection_ids && tab.collection_ids.length) params.append('collection_ids', tab.collection_ids.join(','));
            } else if (tab.source_type === 'products') {
                params.append('product_ids', tab.product_ids.join(','));
            }

            axios.get(this.url + '?' + params.toString())
                .then(res => {
                    const data = res.data.data ? res.data.data : [];
                    this.cache[tab.id] = data;
                    this.isLoading = false;
                    this.renderKey++;
                })
                .catch(err => {
                    console.error('Error fetching products:', err);
                    this.cache[tab.id] = [];
                    this.isLoading = false;
                });
        },
    },
}
</script>

<style scoped>
.ps-product-categories-tabs .ps-section__links {
    display: flex;
    flex-wrap: wrap;
    gap: 0;
    list-style: none;
    padding: 0;
    margin: 0 0 30px 0;
}

.ps-product-categories-tabs .ps-section__links li a {
    color: var(--color-text);
    font-size: 22px;
    font-weight: bold;
    padding: 8px 16px 16px;
    border-bottom: 3px solid var(--color-grey-1);
    transition: all 0.3s ease;
    display: inline-block;
    cursor: pointer;
}

.ps-product-categories-tabs .ps-section__links li a:hover,
.ps-product-categories-tabs .ps-section__links li a.active {
    border-color: var(--color-1st);
    color: var(--color-1st);
}
</style>
